'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('payments-overview', {
      url: '/payments',
      template: '<payments-overview></payments-overview>',
      authenticate: 'suite-admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/payments/overview/payments-overview.routes.js